export default {
  data() {
    return {
      cards: [],
    };
  },
  computed: {
    items() {
      return this.sets
        ? Array.sort(this.sets.sets, (a, b) => a.sort_order == b.sort_order ? 0 : (a.sort_order > b.sort_order ? 1 : -1))
        : [];
    },
  },
  methods: {
    next(i) {
      this.$store.dispatch('SET_PRODUCT_SET', this.items[i]);
      this.$store.dispatch('ADD_PREV_ORDER_STEP', this.orderStep);
      this.$store.dispatch('SET_ORDER_STEP', '3-set-confirm');
    },
  },
  created() {
    this.items.forEach((item) => {
      this.cards.push({
        show: true,
        price: item.price_gross,
      });
    });
  },
};
